import React from 'react';
import pdfImage from "../../../assets/images/allNotices/pdf.png";
import formatDate from "../../../utils/formatDate";
import {fileDownload} from "../../../utils/fetchData";
import downloadFileType from "../../../config/downloadFileType.json";

const AllNoticesTable = ({notices, activePage, pageSize}) => {
    const handleDownload = async (fileName) => {
        await fileDownload(fileName, downloadFileType.NOTICE);
    }
    return (
        <>
            <div className='table-responsive'>
                <table className="table table-bordered notice-table">
                    <thead className='text-nowrap'>
                    <tr>
                        <th className="text-center">S.N.</th>
                        <th>Description</th>
                        <th className="text-center">Release date</th>
                        <th className="text-center">Download</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        notices && notices.map((notice, index) => (
                            <tr key={notice.id}>
                                <td>{(activePage - 1) * pageSize + index + 1}</td>
                                <td>{notice.titleEn}</td>
                                <td>{formatDate(notice.updateTime)}</td>
                                <td>
                                    <img
                                        onClick={() => handleDownload(notice.fileTag)}
                                        className="mx-4 clickable"
                                        src={pdfImage}
                                        alt="pdf image"
                                    />
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default AllNoticesTable;
